
import React, { useState, useEffect,useRef } from 'react';

import CardContent from '@material-ui/core/CardContent';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import TextEvents from '../TextEvents';
import { Card, Avatar, Icon, message, Modal } from 'antd';
import classNames from 'classnames';
import { setTimeout } from 'timers';
import './CommunicationStyles.css'
import convertBase64toBlob from 'app/utils/ConvertBase64ToBlob';
import { useDispatch, useSelector } from 'react-redux';
import * as CommunicationActions from '../../actions/CommunicationActions'
import MediaPlayer from '../MediaPlayer';


const loadLibrary = () => new Promise((resolve, reject) => {
    let scriptTag = document.createElement('script')
    let linkTag = document.createElement('link')
    linkTag.rel = 'stylesheet'
    document.body.appendChild(scriptTag)
    document.head.insertBefore(linkTag, document.head.firstChild)

})

export default function CommunicationForm(props) {
    const welcomeText = `Bienvenido a la prueba ${props.data.courseName} 
    del programa de comunicación ${props.data.diffusionName}, una vez visto el video podrás comenzar la evaluación`;
    const workCycleText = `Bienvenido a la prueba "${props.data.courseName}" del programa de comunicación "${props.data.communicationProgramName}", si estas listo, comienza la evaluación.`
    // const videoNode = React.createRef()
    const skin = 'amp-default';
    const onBoard = process.env.REACT_APP_ON_BOARD_URL;
    const dispatch = useDispatch();
    const { confirm } = Modal;
    const [playerVideo, setPlayerVideo] = useState({
		urlStream: '',
		dashStream: '',
		hlsStream: '',
        timeVideo: 0
	});

    useEffect(() => {
        if (!props.isWorkCycle) 
            setTimeout(
                function () {
                    if (props.data.timeVideo > 0) {
                        showSeconds()
                    } else {
                        createPlayer(0)
                        props.setIsFinished(true)
                    }

                },
                1
            );
        
        }, []
    )

    const showSeconds = () => {
        confirm({
            title: '¿Desea continuar el video desde la ultima visualización?',
            okText: 'Continuar',
            okType: 'success',
            cancelText: 'Cancelar',
            onOk() {
                createPlayer(props.data.timeVideo)
                props.setIsFinished(true)
            },
            onCancel() {
                createPlayer(0)
                props.setIsFinished(true)
            },
        });
    }

    const createPlayer = (timeVideo) => {
        if (playerVideo.urlStream === '') {     
			setPlayerVideo({
                urlStream: props.data.azureURL,
                hlsStream: props.data.hls,
                dashStream: props.data.dash,
                timeVideo: timeVideo,
                thumbnail: props.data.thumbnailImage
            });

		}        
    }

    return (
        <div className={props.isWorkCycle ? props.classes.rootCommunication : props.classes.root} style={{ marginBottom: '7%' }}>
            <Grid container

                justify="flex-start"
                alignItems="stretch" className={props.classes.secondRoot}>
                <Grid xs={12} item >
                    <Card className={props.classes.cardRoot}>
                        <Grid xs={12} item className={props.classes.gridSeparatorTop}>
                            <CardContent className={props.classes.card}>
                                <div className={props.classes.root}>
                                    <Avatar size={100} src={props.isWorkCycle ? (typeof props.data === 'undefined' ? '' : props.data.avatar) : (typeof props.employeeData === 'undefined' ? '' : props.employeeData.avatar)} icon="user" />
                                </div>
                                <Divider />
                            </CardContent>
                        </Grid>
                        <Grid xs={12} item className={props.classes.gridSeparatorTop}>
                            Evaluado
                            <TextEvents
                                text={props.isWorkCycle ? props.data.employeeName : props.userData.FirstName + ' '
                                    + props.userData.LastName + ' ' + props.userData.LastNameSecond}
                                color='darker'
                                size='label'
                                weight='bold'
                            />
                        </Grid>
                        <Divider />
                        <Grid xs={12} item className={props.classes.gridSeparatorTop}>
                            Ficha
                            <TextEvents
                                text={props.isWorkCycle ? props.data.employeeId : props.userData.IdCompany == null ? props.userData.UserId : props.userData.IdCompany}
                                color='darker'
                                size='label'
                                weight='bold'
                            />
                        </Grid>
                        <Divider />
                        <Grid xs={12} item className={props.classes.gridSeparatorTop}>
                            Categoría
                            <TextEvents
                                text={props.isWorkCycle ? props.data.categoryName : props.userData.Position}
                                color='darker'
                                size='label'
                                weight='bold'
                            />
                        </Grid>
                        <Divider />
                        {
                            props.isWorkCycle ?
                                <Grid xs={12} item className={props.classes.gridSeparatorTop}>
                                    Subdirección
                                    <TextEvents
                                        text={props.data.subdirectionName !== undefined ? props.data.subdirectionName : 'N/A'}
                                        color='darker'
                                        size='label'
                                        weight='bold'
                                    />
                                </Grid>

                                : null
                        }
                        {
                            props.isWorkCycle ?
                                <Divider /> : null
                        }
                        {
                            props.isWorkCycle ?
                                <Grid xs={12} item className={props.classes.gridSeparatorTop}>
                                    Contrato
                                    <TextEvents
                                        text={props.data.contractName == undefined || props.data.contractName == null ? 'N/A' : props.data.contractName}
                                        color='darker'
                                        size='label'
                                        weight='bold'
                                    />
                                </Grid>

                                : null
                        }
                        {
                            props.isWorkCycle ?
                                <Divider /> : null
                        }
                        {
                            props.isWorkCycle ?
                                <Grid xs={12} item className={props.classes.gridSeparatorTop}>
                                    Obra
                                    <TextEvents
                                        text={props.data.workName == undefined || props.data.contractName == null ? 'N/A' : props.data.workName}
                                        color='darker'
                                        size='label'
                                        weight='bold'
                                    />
                                </Grid>

                                : null
                        }
                        {
                            props.isWorkCycle ?
                                <Divider /> : null
                        }
                        {props.isWorkCycle ?
                            <div>
                                <Grid xs={12} item className={props.classes.gridSeparatorTop}>
                                    Estatus
                                    <TextEvents
                                        text={props.data.statusName}
                                        color='darker'
                                        size='label'
                                        weight='bold'
                                    />
                                </Grid>
                                <Divider />
                            </div> : ''}
                    </Card>
                </Grid>
            </Grid>
            <Grid container  >
                <Grid container justify="flex-start" style={{ padding: '8px' }}>
                    <Grid item xs={2} sm={12} >
                        <TextEvents
                            text={props.data.courseName}
                            color='darker'
                            size='title'
                            weight='bold'
                        />
                    </Grid>
                    <Grid item xs={6} sm={2} className={props.classes.textItems}>
                        <Icon type="question-circle" style={{ color: '#FF7333', paddingRight: '2px' }} />
                        <TextEvents
                            text={props.data.testQuestionsApply + ' preguntas'}
                            color='darker'
                            size='small'
                            weight='regular'
                        />
                    </Grid>
                    {props.isWorkCycle ? <div /> : <Grid item xs={6} sm={2} className={props.classes.textItems}>
                        <Icon type="clock-circle" style={{ color: '#FF7333', paddingRight: '2px' }} />
                        <TextEvents
                            text={props.data.testDuration + ' minutos'}
                            color='darker'
                            size='small'
                            weight='regular'
                        />
                    </Grid>}
                    {
                        props.visibleEvaluationCTMultiple ? null
                            :
                            <Grid item xs={6} sm={12} style={{ paddingTop: '8px' }}>
                                <TextEvents
                                    text={props.isWorkCycle ? workCycleText : welcomeText}
                                    color='darker'
                                    size='small'
                                    weight='regular'
                                />
                            </Grid>
                    }
                    {/* <Grid item xs={6} sm={12} style={{ paddingTop: '8px' }}>
                        <TextEvents
                            text={props.isWorkCycle ? workCycleText : welcomeText}
                            color='darker'
                            size='small'
                            weight='regular'
                        />
                    </Grid> */}

                </Grid>
                {props.isWorkCycle ? <div /> : <Grid container item sm={12} align = "center" justify = "center" alignItems = "center">
                    <Box alignItems="center" justifyContent="center" style={{ width: '75%', height:'100%'  }}>
                    { playerVideo.urlStream === '' ? <div /> : <MediaPlayer videoData={playerVideo}
                            idCommunication={props.data.idCommunication} setIsFinished={props.setIsFinished} parent={"Communication"}></MediaPlayer> }
                    </Box>
                </Grid>}
            </Grid>
        </div>
    );
}